import React from 'react';
import { StickerTemplate } from '../../../../../services/exports/Constants';
import StickerOneForm from './StickerOneForm';

export default function StickerForm({ template, ...rest }) {
  const FormComponent =
    {
      [StickerTemplate.One]: StickerOneForm,
    }[template] ?? null;

  return <FormComponent {...rest} />;
}
